package com.evoapps.evoshift.domain.di

import com.evoapps.evoshift.domain.usecase.finance.AddOneOffCostUseCase
import com.evoapps.evoshift.domain.usecase.finance.DeleteAdjustmentUseCase
import com.evoapps.evoshift.domain.usecase.finance.SaveAdjustmentUseCase
import com.evoapps.evoshift.domain.usecase.finance.DeleteOneOffCostUseCase
import com.evoapps.evoshift.domain.usecase.finance.MigrateOneOffCostRulesUseCase
import com.evoapps.evoshift.domain.usecase.shift.MarkShiftsOpenUseCase
import com.evoapps.evoshift.domain.usecase.NotifyRelevantEmployeesUseCase
import com.evoapps.evoshift.domain.usecase.AcceptInviteUseCase
import com.evoapps.evoshift.domain.usecase.AddEngagementUseCase
import com.evoapps.evoshift.domain.usecase.AddShiftToDayTemplateUseCase
import com.evoapps.evoshift.domain.usecase.ApplyWeeklySkeletonUseCase
import com.evoapps.evoshift.domain.usecase.GetDayClosuresUseCase
import com.evoapps.evoshift.domain.usecase.weather.ObserveWorkplaceWeatherUseCase
import com.evoapps.evoshift.domain.usecase.AssignUserToShiftUseCase
import com.evoapps.evoshift.domain.usecase.CalculateShiftCostUseCase
import com.evoapps.evoshift.domain.usecase.CloseDayUseCase
import com.evoapps.evoshift.domain.usecase.CreateDayTemplateUseCase
import com.evoapps.evoshift.domain.usecase.CreateRosterUseCase
import com.evoapps.evoshift.domain.usecase.CreateWorkplaceUseCase
import com.evoapps.evoshift.domain.usecase.DeleteDayTemplateUseCase
import com.evoapps.evoshift.domain.usecase.DeleteShiftTemplateUseCase
import com.evoapps.evoshift.domain.usecase.DetectRosterConflictsUseCase
import com.evoapps.evoshift.domain.usecase.DuplicateDayTemplateUseCase
import com.evoapps.evoshift.domain.usecase.FinalizeRosterSkeletonUseCase
import com.evoapps.evoshift.domain.usecase.GetAvailabilityRequestUseCase
import com.evoapps.evoshift.domain.usecase.GetAvailabilityUseCase
import com.evoapps.evoshift.domain.usecase.GetEmployeeDashboardUseCase
import com.evoapps.evoshift.domain.usecase.GetManagerDashboardUseCase
import com.evoapps.evoshift.domain.usecase.ObserveRosterChangesUseCase
import com.evoapps.evoshift.domain.usecase.finance.RepriceFutureShiftsUseCase
import com.evoapps.evoshift.domain.usecase.reports.GenerateWorkingTimeReportUseCase
import com.evoapps.evoshift.domain.usecase.GetOwnerUseCase
import com.evoapps.evoshift.domain.usecase.GetRosterAvailabilityUseCase
import com.evoapps.evoshift.domain.usecase.GetSkeletonEditorDataUseCase
import com.evoapps.evoshift.domain.usecase.GetWorkplaceUseCase
import com.evoapps.evoshift.domain.usecase.PublishRosterUseCase
import com.evoapps.evoshift.domain.usecase.RemoveShiftFromDayTemplateUseCase
import com.evoapps.evoshift.domain.usecase.RenameDayTemplateUseCase
import com.evoapps.evoshift.domain.usecase.ReportAbsenceUseCase
import com.evoapps.evoshift.domain.usecase.ResolveAbsenceConflictsUseCase
import com.evoapps.evoshift.domain.usecase.SendAvailabilityRequestUseCase
import com.evoapps.evoshift.domain.usecase.SendOnboardingInviteUseCase
import com.evoapps.evoshift.domain.usecase.UnassignShiftFromEmployeeUseCase
import com.evoapps.evoshift.domain.usecase.UpdateShiftTemplateUseCase
import com.evoapps.evoshift.domain.usecase.UpdateUserProfileUseCase
import com.evoapps.evoshift.domain.usecase.UpdateWeeklySkeletonUseCase
import com.evoapps.evoshift.domain.usecase.ValidateInviteUseCase
import com.evoapps.evoshift.domain.usecase.auth.CallerCapabilities
import com.evoapps.evoshift.domain.usecase.auth.GetCurrentUserUseCase
import com.evoapps.evoshift.domain.usecase.auth.AppleSignInUseCase
import com.evoapps.evoshift.domain.usecase.auth.GoogleSignInUseCase
import com.evoapps.evoshift.domain.usecase.auth.DeleteAccountUseCase
import com.evoapps.evoshift.domain.usecase.auth.LoginUseCase
import com.evoapps.evoshift.domain.usecase.auth.RegisterDeviceTokenUseCase
import com.evoapps.evoshift.domain.usecase.auth.RegisterUserUseCase
import com.evoapps.evoshift.domain.usecase.auth.ResetPasswordUseCase
import com.evoapps.evoshift.domain.usecase.auth.CompleteSetupUseCase
import com.evoapps.evoshift.domain.usecase.auth.SendEmailVerificationUseCase
import com.evoapps.evoshift.domain.usecase.auth.CheckEmailVerificationUseCase
import com.evoapps.evoshift.domain.usecase.auth.SignOutUseCase
import com.evoapps.evoshift.domain.usecase.availability.ApplyWeeklyAvailabilityTemplateUseCase
import com.evoapps.evoshift.domain.usecase.availability.DeleteWeeklyAvailabilityTemplateUseCase
import com.evoapps.evoshift.domain.usecase.availability.GetWeeklyAvailabilityTemplatesUseCase
import com.evoapps.evoshift.domain.usecase.availability.SaveWeeklyAvailabilityTemplateUseCase
import com.evoapps.evoshift.domain.usecase.daily.GetDailyLogUseCase
import com.evoapps.evoshift.domain.usecase.daily.SubmitDailyRevenueUseCase
import com.evoapps.evoshift.domain.usecase.daily.UpdateDailyTargetUseCase
import com.evoapps.evoshift.domain.usecase.daily.FindMissingDailyResultsUseCase
import com.evoapps.evoshift.domain.usecase.financial.AddFinancialAdjustmentUseCase
import com.evoapps.evoshift.domain.usecase.financial.GeneratePayrollReportUseCase
import com.evoapps.evoshift.domain.usecase.financial.GetRealTimeLaborPercentageUseCase
import com.evoapps.evoshift.domain.usecase.finance.CalculateDailyRecordUseCase
import com.evoapps.evoshift.domain.usecase.finance.GetMonthTrendUseCase
import com.evoapps.evoshift.domain.usecase.finance.ImportDailySalesUseCase
import com.evoapps.evoshift.domain.usecase.finance.RegenerateDailyRecordsUseCase
import com.evoapps.evoshift.domain.usecase.finance.GetRevenuePlanUseCase
import com.evoapps.evoshift.domain.usecase.finance.GetStaffingHintsUseCase
import com.evoapps.evoshift.domain.usecase.finance.GetSalesForecastUseCase
import com.evoapps.evoshift.domain.usecase.marketplace.ApproveSwapRequestUseCase
import com.evoapps.evoshift.domain.usecase.marketplace.CancelSwapRequestUseCase
import com.evoapps.evoshift.domain.usecase.marketplace.RejectSwapRequestUseCase
import com.evoapps.evoshift.domain.usecase.marketplace.RequestShiftSwapUseCase
import com.evoapps.evoshift.domain.usecase.marketplace.TakeShiftFromPoolUseCase
import com.evoapps.evoshift.domain.usecase.roster.DeleteRosterUseCase
import com.evoapps.evoshift.domain.usecase.roster.GetRosterFinancialsUseCase
import com.evoapps.evoshift.domain.usecase.roster.GetRosterShiftsUseCase
import com.evoapps.evoshift.domain.usecase.roster.GetRosterSummaryUseCase
import com.evoapps.evoshift.domain.usecase.roster.GetRosterUseCase
import com.evoapps.evoshift.domain.usecase.settings.CreateRecurringCostRuleUseCase
import com.evoapps.evoshift.domain.usecase.settings.CreateShiftTemplateUseCase
import com.evoapps.evoshift.domain.usecase.settings.DeleteRecurringCostRuleUseCase
import com.evoapps.evoshift.domain.usecase.settings.GetRecurringCostRulesUseCase
import com.evoapps.evoshift.domain.usecase.settings.UpdateRecurringCostRuleUseCase
import com.evoapps.evoshift.domain.usecase.UpdateOwnerBusinessNameUseCase
import com.evoapps.evoshift.domain.usecase.settings.DeleteWorkplaceUseCase
import com.evoapps.evoshift.domain.usecase.settings.UpdateWorkplaceFinancialsUseCase
import com.evoapps.evoshift.domain.usecase.settings.SaveSalesTargetsUseCase
import com.evoapps.evoshift.domain.usecase.settings.UpdateWorkplaceLocationUseCase
import com.evoapps.evoshift.domain.usecase.settings.UpdateWorkplaceNameUseCase
import com.evoapps.evoshift.domain.usecase.settings.UpdateWorkplaceSettingsUseCase
import com.evoapps.evoshift.domain.usecase.owner.AddContractTypeUseCase
import com.evoapps.evoshift.domain.usecase.owner.DeleteContractTypeUseCase
import com.evoapps.evoshift.domain.usecase.owner.GetContractTypesUseCase
import com.evoapps.evoshift.domain.usecase.owner.UpdateContractTypeUseCase
import com.evoapps.evoshift.domain.usecase.schedule.ApplyAutoScheduleUseCase
import com.evoapps.evoshift.domain.usecase.schedule.PlanAutoScheduleUseCase
import com.evoapps.evoshift.domain.usecase.capacity.GetRosterCapacityUseCase
import com.evoapps.evoshift.domain.usecase.capacity.RemindAvailabilityUseCase
import com.evoapps.evoshift.domain.usecase.shift.DeleteShiftUseCase
import com.evoapps.evoshift.domain.usecase.shift.ClockInClockOutUseCase
import com.evoapps.evoshift.domain.usecase.shift.CreateShiftUseCase
import com.evoapps.evoshift.domain.usecase.shift.UpdateShiftTimesUseCase
import com.evoapps.evoshift.domain.usecase.shift.UpdateShiftUseCase
import com.evoapps.evoshift.domain.usecase.team.GetTeamStatusUseCase
import com.evoapps.evoshift.domain.usecase.team.GetPeopleFromOtherWorkplacesUseCase
import com.evoapps.evoshift.domain.usecase.user.CreateEmployeeUseCase
import com.evoapps.evoshift.domain.usecase.user.ExportMyDataUseCase
import com.evoapps.evoshift.domain.usecase.user.RemoveProfilePhotoUseCase
import com.evoapps.evoshift.domain.usecase.user.UploadProfilePhotoUseCase
import com.evoapps.evoshift.domain.usecase.user.ExportWorkplaceDataUseCase
import com.evoapps.evoshift.domain.usecase.user.GetAssignableEmployeesUseCase
import com.evoapps.evoshift.domain.usecase.user.GetEmployeeDetailsUseCase
import com.evoapps.evoshift.domain.usecase.user.GetMyRosterUseCase
import com.evoapps.evoshift.domain.usecase.user.SubmitAvailabilityUseCase
import com.evoapps.evoshift.domain.usecase.user.TerminateEngagementUseCase
import com.evoapps.evoshift.domain.usecase.user.UpdateEmployeeUseCase
import com.evoapps.evoshift.domain.usecase.CreateStarterScheduleUseCase
import com.evoapps.evoshift.domain.usecase.billing.CheckPlanLimitUseCase
import com.evoapps.evoshift.domain.usecase.billing.CheckSeatsUseCase
import com.evoapps.evoshift.domain.usecase.billing.ObserveWorkplacePlanUseCase
import com.evoapps.evoshift.domain.usecase.billing.ObservePlanActiveUseCase
import com.evoapps.evoshift.domain.usecase.billing.ObserveSeatsInUseUseCase
import com.evoapps.evoshift.domain.usecase.billing.GetPlanOffersUseCase
import com.evoapps.evoshift.domain.usecase.billing.ManageSubscriptionUseCase
import com.evoapps.evoshift.domain.usecase.billing.ObserveOwnerPlanUseCase
import com.evoapps.evoshift.domain.usecase.billing.PurchasePlanUseCase
import com.evoapps.evoshift.domain.usecase.billing.ResetBillingIdentityUseCase
import com.evoapps.evoshift.domain.usecase.billing.RestorePurchasesUseCase
import org.kodein.di.DI
import org.kodein.di.bind
import org.kodein.di.bindProvider
import org.kodein.di.instance
import org.kodein.di.instanceOrNull
import org.kodein.di.provider
import org.kodein.di.singleton

val domainModule = DI.Module("domainModule") {
    bind<LoginUseCase>() with singleton { LoginUseCase(instance()) }
    bind<DeleteAccountUseCase>() with singleton { DeleteAccountUseCase(instance()) }
    bind<GoogleSignInUseCase>() with singleton { GoogleSignInUseCase(instance(), instance()) }
    bind<AppleSignInUseCase>() with singleton { AppleSignInUseCase(instance(), instance()) }
    bind<CloseDayUseCase>() with singleton { CloseDayUseCase(instance()) }
    bind<CreateShiftUseCase>() with singleton { CreateShiftUseCase(instance(), calculateShiftCost = instance()) }
    bind<DeleteShiftUseCase>() with singleton { DeleteShiftUseCase(instance()) }
    bind<GetDailyLogUseCase>() with singleton { GetDailyLogUseCase(instance()) }
    bind<GetMyRosterUseCase>() with singleton { GetMyRosterUseCase(instance()) }
    bind<GetDayClosuresUseCase>() with singleton { GetDayClosuresUseCase(instance()) }
    // SH-226: the workplace's weather (written by functions/weather.js).
    bind<ObserveWorkplaceWeatherUseCase>() with singleton { ObserveWorkplaceWeatherUseCase(instance()) }
    // SH-227: local events and special days (school breaks, long weekends).
    bind<com.evoapps.evoshift.domain.usecase.specialdays.ObserveSpecialDaysUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.specialdays.ObserveSpecialDaysUseCase(instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.specialdays.SaveLocalEventUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.specialdays.SaveLocalEventUseCase(instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.specialdays.DeleteLocalEventUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.specialdays.DeleteLocalEventUseCase(instance())
    }
    bind<ApplyWeeklySkeletonUseCase>() with provider {
        ApplyWeeklySkeletonUseCase(instance(), instance(), instance())
    }

    bind<CreateRosterUseCase>() with provider {
        CreateRosterUseCase(
            rosterRepository = instance(),
            workplaceRepository = instance(),
            regenerateDailyRecordsUseCase = instance(),
            applyWeeklySkeletonUseCase = instance(),
            caller = instance(),
            shiftRepository = instance()
        )
    }
    // SH-172: availability for a month before (or without) its demand.
    bindProvider { com.evoapps.evoshift.domain.usecase.availability.RequestAvailabilityForMonthUseCase(instance(), instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.availability.GetMonthAnswersUseCase(instance(), instance(), instance(), instance()) }
    bind<DeleteRosterUseCase>() with provider {
        DeleteRosterUseCase(instance())
    }
    bind<AddEngagementUseCase>() with singleton { AddEngagementUseCase(instance()) }
    bind<PublishRosterUseCase>() with singleton {
        PublishRosterUseCase(
            rosterRepository = instance(),
            shiftRepository = instance(),
            userRepository = instance(),
            workplaceRepository = instance(),
            regenerateDailyRecordsUseCase = instance(),
            calculateShiftCostUseCase = instance(),
            deleteShiftUseCase = instance()
        )
    }
    bind<ReportAbsenceUseCase>() with singleton { ReportAbsenceUseCase(instance(), instance(), instance(), instance(), instance()) }
    // SH-223: remote work, work events and overtime; the shared places; the limits at approval.
    bind<com.evoapps.evoshift.domain.usecase.requests.SubmitWorkRequestUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.requests.SubmitWorkRequestUseCase(instance(), instance(), instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.requests.DecideWorkRequestUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.requests.DecideWorkRequestUseCase(instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.requests.WorkPlacesUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.requests.WorkPlacesUseCase(instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.requests.CheckApprovalLimitUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.requests.CheckApprovalLimitUseCase(instance(), instance(), instance())
    }
    // SH-224: SH-223's decision on an absence, shared by the Requests tab and the timeline.
    bind<com.evoapps.evoshift.domain.usecase.requests.DecideAbsenceUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.requests.DecideAbsenceUseCase(instance(), instance(), instance())
    }
    // SH-224: the person's requests on their timeline.
    bind<com.evoapps.evoshift.domain.timeline.TimelineRequestsUseCase>() with singleton {
        com.evoapps.evoshift.domain.timeline.TimelineRequestsUseCase(
            absences = instance(), workRequests = instance(), reportAbsence = instance(), submitWorkRequest = instance(),
            decideAbsence = instance(), decideWorkRequest = instance(), places = instance()
        )
    }
    bind<GetCurrentUserUseCase>() with singleton { GetCurrentUserUseCase(instance()) }
    bind<ClockInClockOutUseCase>() with singleton { ClockInClockOutUseCase(instance(), workplaceRepository = instance()) }
    bind<CreateWorkplaceUseCase>() with singleton { CreateWorkplaceUseCase(instance(), instance(), instance()) }
    bind<GetOwnerUseCase>() with singleton { GetOwnerUseCase(instance()) }
    bind<GetRosterSummaryUseCase>() with singleton { GetRosterSummaryUseCase(instance()) }
    bind<RegisterUserUseCase>() with singleton { RegisterUserUseCase(instance()) }
    bind<ResetPasswordUseCase>() with singleton { ResetPasswordUseCase(instance()) }
    bind<CompleteSetupUseCase>() with singleton { CompleteSetupUseCase(instance()) }
    bind<SendEmailVerificationUseCase>() with singleton { SendEmailVerificationUseCase(instance()) }
    bind<CheckEmailVerificationUseCase>() with singleton { CheckEmailVerificationUseCase(instance()) }
    bind<SignOutUseCase>() with singleton { SignOutUseCase(instance()) }
    bindProvider { GetSkeletonEditorDataUseCase(instance()) }
    bindProvider { UpdateWeeklySkeletonUseCase(instance()) }
    bindProvider { CreateDayTemplateUseCase(instance()) }
    bindProvider { AddShiftToDayTemplateUseCase(instance()) }
    bindProvider { RemoveShiftFromDayTemplateUseCase(instance()) }
    bindProvider { RenameDayTemplateUseCase(instance()) }
    bindProvider { DeleteDayTemplateUseCase(instance()) }
    bindProvider { DuplicateDayTemplateUseCase(instance()) }
    bindProvider { UpdateShiftTemplateUseCase(instance()) }
    bindProvider { DeleteShiftTemplateUseCase(instance()) }
    bindProvider { GetWorkplaceUseCase(instance()) }
    bindProvider { CreateEmployeeUseCase(instance()) }
    // SH-192: people of the caller's other workplaces, for Team → Add employee.
    bindProvider { GetPeopleFromOtherWorkplacesUseCase(instance(), instance()) }
    bindProvider { UpdateEmployeeUseCase(instance()) }
    bindProvider { FinalizeRosterSkeletonUseCase(instance()) }
    bindProvider { ValidateInviteUseCase(instance()) }
    bindProvider { AcceptInviteUseCase(instance()) }
    bindProvider { GetTeamStatusUseCase(
        instance(),
        shiftRepository = instance()
    ) }
    bindProvider { NotifyRelevantEmployeesUseCase(instance(), instance()) }
    bindProvider { SendAvailabilityRequestUseCase(instance(), instance(), instance()) }
    bindProvider { GetAvailabilityRequestUseCase(instance()) }
    bindProvider { GetRosterAvailabilityUseCase(instance()) }
    bind<RequestShiftSwapUseCase>() with singleton {
        RequestShiftSwapUseCase(
            instance(),
            instance(),
            instance(),
            instance(),
            // SH-255: someone hidden in the roster offers a shift through the managers.
            rosterPrivacy = instanceOrNull()
        )
    }
    // SH-255: "Hide in the roster for others".
    bindProvider { com.evoapps.evoshift.domain.privacy.GetHiddenInRosterUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.privacy.SetHiddenInRosterUseCase(instance()) }
    bind<UpdateShiftTimesUseCase>() with singleton { UpdateShiftTimesUseCase(instance()) }
    bind<UpdateShiftUseCase>() with singleton { UpdateShiftUseCase(instance(), instance()) }
    bind<MarkShiftsOpenUseCase>() with singleton { MarkShiftsOpenUseCase(instance()) }
    bind<AssignUserToShiftUseCase>() with singleton {
        AssignUserToShiftUseCase(
            shiftRepository = instance(),
            availabilityRepository = instance(),
            userRepository = instance(),
            rosterRepository = instance(),
            calculateShiftCostUseCase = instance(),
            staffRepository = instance(),
            workplaceRepository = instance(),
            caller = instance()
        )
    }
    // Tip split (SH-124)
    bindProvider { com.evoapps.evoshift.domain.usecase.tips.PreviewTipSplitUseCase(instance(), instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.tips.SaveTipPoolUseCase(instance()) }
    // Leave balances (SH-113)
    bindProvider { com.evoapps.evoshift.domain.usecase.leave.GetMyLeaveEntitlementUseCase(instance(), instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.leave.GetTeamLeaveBalancesUseCase(instance(), instance(), instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.leave.SaveLeaveAllowanceUseCase(instance()) }
    // Staff fields (SH-47)
    bindProvider { com.evoapps.evoshift.domain.usecase.staff.GetStaffDetailsUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.staff.SaveStaffRecordUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.staff.SaveAvailabilityNotesUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.staff.GetTeamReadinessUseCase(instance(), instance()) }
    // Documents and policies (SH-122)
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.GetStaffDocumentsUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.UploadStaffDocumentUseCase(instance(), instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.DeleteStaffDocumentUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.OpenStaffDocumentUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.GetPoliciesUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.PublishPolicyUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.DeletePolicyUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.OpenPolicyUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.AcknowledgePolicyUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.documents.GetPolicyReadReportUseCase(instance(), instance()) }
    // Training courses and the OHS training record (SH-126)
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.GetManagedCoursesUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.GetCourseForEditingUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.SaveCourseUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.DeleteCourseUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.UploadCourseImageUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.LoadCourseImageUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.UploadCoursePresentationUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.LoadCoursePresentationUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.NewCourseIdUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.GetMyCoursesUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.GetCourseToTakeUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.SaveCourseProgressUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.SubmitCourseUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.AssignCourseUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.UnassignCourseUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.GetCourseProgressReportUseCase(instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.GetOhsRecordUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.RecordOhsTrainingUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.ConfirmOhsTrainingUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.GetOhsDocumentUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.courses.GetTrainingStatusesUseCase(instance()) }
    bind<UnassignShiftFromEmployeeUseCase>() with singleton {
        UnassignShiftFromEmployeeUseCase(
            instance(),
            instance()
        )
    }
    bind<CancelSwapRequestUseCase>() with singleton { CancelSwapRequestUseCase(instance()) }
    bind<com.evoapps.evoshift.domain.usecase.marketplace.GetSwapCandidatesUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.marketplace.GetSwapCandidatesUseCase(instance())
    }
    bind<RejectSwapRequestUseCase>() with singleton { RejectSwapRequestUseCase(instance(), instance()) }
    // SH-164: the Requests badges and list, and the one-tap approvals' Undo.
    bind<com.evoapps.evoshift.domain.usecase.requests.ObservePendingRequestsUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.requests.ObservePendingRequestsUseCase(instance(), instance(), instance(), instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.requests.UndoAbsenceDecisionUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.requests.UndoAbsenceDecisionUseCase(instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.requests.UndoSwapApprovalUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.requests.UndoSwapApprovalUseCase(instance(), instance())
    }
    bind<TakeShiftFromPoolUseCase>() with singleton { TakeShiftFromPoolUseCase(instance(), instance()) }
    bind<UpdateUserProfileUseCase>() with singleton { UpdateUserProfileUseCase(instance()) }
    bind<ApproveSwapRequestUseCase>() with singleton { ApproveSwapRequestUseCase(instance(), instance(), instance(), instance()) }
    bind<CalculateShiftCostUseCase>() with singleton {
        CalculateShiftCostUseCase(
            instance(),
            instance(),
            instance(),
            instance(),
            caller = instance()
        )
    }
    bind<GetEmployeeDetailsUseCase>() with singleton { GetEmployeeDetailsUseCase(instance()) }
    // SH-135: one availability for all of a person's workplaces.
    bindProvider { com.evoapps.evoshift.domain.usecase.availability.AvailabilityDistribution(instance(), instance(), instance()) }
    bind<SubmitAvailabilityUseCase>() with singleton { SubmitAvailabilityUseCase(instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.availability.GetMyAvailabilityUseCase(instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.availability.GetAvailabilitySharingUseCase(instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.availability.SetAvailabilitySharingUseCase(instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.roster.GetBusyElsewhereUseCase(instance()) }
    bind<SubmitDailyRevenueUseCase>() with singleton { SubmitDailyRevenueUseCase(instance(), instance()) }
    // SH-46: planned times copied into the actual ones (Daily Records).
    // SH-134: the managers' decisions on flagged and unplanned clock times.
    bind<com.evoapps.evoshift.domain.usecase.shift.ReviewClockUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.shift.ReviewClockUseCase(instance(), instance(), instance(), instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.shift.CopyPlannedTimesToActualUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.shift.CopyPlannedTimesToActualUseCase(instance(), instance(), instance(), instance())
    }
    // SH-128: who worked an open shift of a past day (Daily Records), and its cost.
    // SH-236: who actually worked, splitting a shift and undoing a split.
    bind<com.evoapps.evoshift.domain.usecase.shift.ShiftWorkFollowUps>() with singleton {
        com.evoapps.evoshift.domain.usecase.shift.ShiftWorkFollowUps(instance(), instance(), instance(), instance(), instance())
    }
    // SH-257: confirming working hours (Godziny pracy) and the team entering their own.
    bind<com.evoapps.evoshift.domain.usecase.shift.ConfirmWorkHoursUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.shift.ConfirmWorkHoursUseCase(instance(), instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.shift.ReportWorkHoursUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.shift.ReportWorkHoursUseCase(instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.shift.RecordActualWorkUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.shift.RecordActualWorkUseCase(instance(), instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.shift.SplitShiftUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.shift.SplitShiftUseCase(instance(), instance(), instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.shift.UndoShiftSplitUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.shift.UndoShiftSplitUseCase(instance(), instance(), instance())
    }
    bind<com.evoapps.evoshift.domain.usecase.shift.RecordShiftWorkerUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.shift.RecordShiftWorkerUseCase(instance(), instance(), instance(), instance())
    }
    bind<UpdateDailyTargetUseCase>() with singleton { UpdateDailyTargetUseCase(instance(), instance()) }
    bind<FindMissingDailyResultsUseCase>() with singleton { FindMissingDailyResultsUseCase(instance(), instance()) }
    bind<CreateShiftTemplateUseCase>() with singleton { CreateShiftTemplateUseCase(instance()) }
    bind<ObserveRosterChangesUseCase>() with singleton { ObserveRosterChangesUseCase(instance(), instance()) }
    bind<GetManagerDashboardUseCase>() with singleton {
        GetManagerDashboardUseCase(
            instance(),
            instance(),
            instance(),
            workplaceRepository = instance()
        )
    }
    bind<GetRosterFinancialsUseCase>() with singleton { GetRosterFinancialsUseCase(instance()) }
    bind<RegisterDeviceTokenUseCase>() with singleton { RegisterDeviceTokenUseCase(instance()) }
    bind<TerminateEngagementUseCase>() with singleton { TerminateEngagementUseCase(instance()) }
    bind<GetEmployeeDashboardUseCase>() with singleton {
        GetEmployeeDashboardUseCase(
            instance(),
            instance(),
            instance(),
            instance(),
            instance(),
            instance()
        )
    }
    // SH-165: the person's own pay facts, for a swap's or a take's change of the estimate.
    bind<com.evoapps.evoshift.domain.usecase.finance.GetOwnPayFactsUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.finance.GetOwnPayFactsUseCase(instance(), instance(), instance(), instance(), instance(), instance())
    }
    bind<SendOnboardingInviteUseCase>() with singleton { SendOnboardingInviteUseCase(instance()) }
    bind<DetectRosterConflictsUseCase>() with singleton { DetectRosterConflictsUseCase(instance()) }
    // Automatic scheduling (SH-44): preview, then apply.
    bindProvider { PlanAutoScheduleUseCase(instance(), instance(), instance(), instance(), instance(), instance(), instance()) }
    bindProvider { ApplyAutoScheduleUseCase(instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.schedule.SuggestAutoScheduleWithAiUseCase(instance(), instance()) }
    // SH-114: "Copy from…" (last week, a chosen week, last month): preview, apply, undo.
    bindProvider {
        com.evoapps.evoshift.domain.usecase.roster.CopyShiftsUseCase(
            instance(), instance(), instance(), instance(), instance(), instance(), instance(), calculateShiftCost = instance(),
            regenerateDailyRecords = instance()
        )
    }
    // Capacity before planning and availability reminders (SH-48).
    bindProvider { GetRosterCapacityUseCase(instance(), instance(), instance(), instance(), instance(), instance()) }
    bindProvider { RemindAvailabilityUseCase(instance(), instance(), instance()) }
    bind<GeneratePayrollReportUseCase>() with singleton {
        GeneratePayrollReportUseCase(
            instance(),
            instance(),
            instance(),
            instance(),
            instance(),
            instance(),
            instance(),
            regenerateDailyRecords = instance(),
            labourInclusion = instance(),
            workRequestRepository = instance()
        )
    }
    bind<AddFinancialAdjustmentUseCase>() with singleton { AddFinancialAdjustmentUseCase(instance()) }
    bindProvider { SaveAdjustmentUseCase(instance(), instance(), instance()) }
    bindProvider { DeleteAdjustmentUseCase(instance(), instance()) }
    bind<GetAssignableEmployeesUseCase>() with singleton { GetAssignableEmployeesUseCase(instance()) }
    bind<com.evoapps.evoshift.domain.usecase.user.ResolvePersonNamesUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.user.ResolvePersonNamesUseCase(instance())
    }
    bind<CreateRecurringCostRuleUseCase>() with singleton { CreateRecurringCostRuleUseCase(instance()) }
    bind<UpdateRecurringCostRuleUseCase>() with singleton { UpdateRecurringCostRuleUseCase(instance()) }
    bind<DeleteRecurringCostRuleUseCase>() with singleton { DeleteRecurringCostRuleUseCase(instance()) }
    bind<GetRecurringCostRulesUseCase>() with singleton { GetRecurringCostRulesUseCase(instance()) }
    bind<UpdateOwnerBusinessNameUseCase>() with singleton { UpdateOwnerBusinessNameUseCase(instance()) }
    bind<UpdateWorkplaceSettingsUseCase>() with singleton { UpdateWorkplaceSettingsUseCase(instance()) }
    bind<UpdateWorkplaceLocationUseCase>() with singleton { UpdateWorkplaceLocationUseCase(instance()) }
    bind<UpdateWorkplaceFinancialsUseCase>() with singleton { UpdateWorkplaceFinancialsUseCase(instance()) }
    bind<SaveSalesTargetsUseCase>() with singleton { SaveSalesTargetsUseCase(instance()) }
    bind<UpdateWorkplaceNameUseCase>() with singleton { UpdateWorkplaceNameUseCase(instance(), instance()) }
    bind<GetContractTypesUseCase>() with singleton { GetContractTypesUseCase(instance()) }
    bind<AddContractTypeUseCase>() with singleton { AddContractTypeUseCase(instance()) }
    bind<UpdateContractTypeUseCase>() with singleton { UpdateContractTypeUseCase(instance()) }
    bind<DeleteContractTypeUseCase>() with singleton { DeleteContractTypeUseCase(instance()) }
    bind<GetRealTimeLaborPercentageUseCase>() with singleton {
        GetRealTimeLaborPercentageUseCase(
            instance()
        )
    }
    bind<GenerateWorkingTimeReportUseCase>() with singleton { GenerateWorkingTimeReportUseCase(instance(), instance(), instance(), instance()) }
    bind<RepriceFutureShiftsUseCase>() with singleton { RepriceFutureShiftsUseCase(instance(), instance(), instance()) }
    bind<ResolveAbsenceConflictsUseCase>() with singleton { ResolveAbsenceConflictsUseCase(instance(), instance()) }
    bind<GetRosterUseCase>() with singleton { GetRosterUseCase(instance()) }
    bind<GetRosterShiftsUseCase>() with singleton { GetRosterShiftsUseCase(instance(), instance()) }
    bind<DeleteWorkplaceUseCase>() with singleton {
        DeleteWorkplaceUseCase(instance(), instance(), instance())
    }
    bind<GetAvailabilityUseCase>() with singleton { GetAvailabilityUseCase(instance()) }
    bind<GetWeeklyAvailabilityTemplatesUseCase>() with singleton {
        GetWeeklyAvailabilityTemplatesUseCase(
            instance()
        )
    }
    bind<SaveWeeklyAvailabilityTemplateUseCase>() with singleton {
        SaveWeeklyAvailabilityTemplateUseCase(
            instance()
        )
    }
    bind<DeleteWeeklyAvailabilityTemplateUseCase>() with singleton {
        DeleteWeeklyAvailabilityTemplateUseCase(
            instance()
        )
    }
    bind<CalculateDailyRecordUseCase>() with singleton {
        CalculateDailyRecordUseCase(
            instance(),
            instance(),
            instance(),
            userRepository = instance(),
            caller = instance(),
            // SH-193: prices unassigned shifts in a month with no priced shift yet.
            teamCostRate = instance(),
            // SH-210: paid interviews count in the labour cost.
            interviewRepository = instance(),
            // SH-206: who counts in the labour cost, labour % and SPMH.
            labourInclusion = instance()
        )
    }
    // SH-212: the employee timeline (effective-dated hire, contract, pay, statuses, OHS, notes).
    bindProvider {
        com.evoapps.evoshift.domain.timeline.EmployeeTimelineUseCase(
            timelines = instance(), users = instance(), staff = instance(), shiftRepository = instance(),
            rosters = instance(), workplaces = instance(), reprice = instance(), labourInclusion = instance()
        )
    }
    // SH-269: several people changed at once (pay and contract through the timeline).
    bindProvider {
        com.evoapps.evoshift.domain.team.BulkEmployeeEditUseCase(
            timeline = instance(), timelines = instance(), team = instance(), rosters = instance()
        )
    }
    // SH-206: "Count in labour cost and SPMH", per person and workplace.
    bind<com.evoapps.evoshift.domain.budget.LabourInclusionReader>() with singleton {
        com.evoapps.evoshift.domain.budget.LabourInclusionReader(instance(), instance())
    }
    bindProvider { com.evoapps.evoshift.domain.budget.GetLabourInclusionUseCase(instance(), instance(), instance(), caller = instance()) }
    bindProvider {
        com.evoapps.evoshift.domain.budget.SetLabourInclusionUseCase(
            instance(), instance(), instance(), rosterRepository = instance(), regenerateDailyRecords = instance(),
            changes = instance(), caller = instance()
        )
    }
    bindProvider { AddOneOffCostUseCase(instance(), instance()) }
    bindProvider { DeleteOneOffCostUseCase(instance(), instance()) }
    bindProvider { MigrateOneOffCostRulesUseCase(instance(), instance(), instance(), instance()) }
    // SH-131: the owner's shared costs of the business, split across the workplaces.
    bindProvider { com.evoapps.evoshift.domain.usecase.owner.GetSharedCostsUseCase(instance()) }
    // SH-136: one per app, so a change on the shared costs screen reaches the screens behind it.
    bind<com.evoapps.evoshift.domain.usecase.owner.SharedCostChanges>() with singleton { com.evoapps.evoshift.domain.usecase.owner.SharedCostChanges() }
    bindProvider { com.evoapps.evoshift.domain.usecase.owner.SaveSharedCostUseCase(instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.owner.DeleteSharedCostUseCase(instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.owner.GetBusinessMonthUseCase(instance()) }
    // SH-267: the owner's workplace groups (who may borrow people from whom).
    bindProvider { com.evoapps.evoshift.domain.usecase.owner.GetWorkplaceGroupsUseCase(instance()) }
    // SH-270: roles and per-person access.
    bindProvider { com.evoapps.evoshift.domain.usecase.access.GetRolesUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.access.SaveRoleUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.access.DeleteRoleUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.access.SetEngagementAccessUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.owner.SaveWorkplaceGroupsUseCase(instance()) }
    // SH-268: who manages every workplace of a group.
    bindProvider { com.evoapps.evoshift.domain.usecase.owner.SaveGroupManagersUseCase(instance()) }
    // SH-269: the group's settings, and a workplace following them or keeping its own per section.
    bindProvider { com.evoapps.evoshift.domain.usecase.owner.SaveGroupSettingsUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.owner.SetSectionInheritanceUseCase(instance()) }
    // SH-147: people working without pay terms, and confirming someone works without pay.
    bind<com.evoapps.evoshift.domain.budget.PayTermsChanges>() with singleton { com.evoapps.evoshift.domain.budget.PayTermsChanges() }
    // SH-170: the home screens' "Do zrobienia", the roster cards' trackers and the first steps.
    bindProvider {
        com.evoapps.evoshift.domain.usecase.todo.ObserveTeamTodoUseCase(
            rosterRepository = instance(),
            shiftRepository = instance(),
            workplaceRepository = instance(),
            userRepository = instance(),
            pendingRequests = instance(),
            findMissingTakings = instance(),
            getMissingPay = instance(),
            getCapacity = instance(),
            payTermsChanges = instance()
        )
    }
    bindProvider {
        com.evoapps.evoshift.domain.usecase.todo.ObserveMyTodoUseCase(
            rosterRepository = instance(),
            shiftRepository = instance(),
            availabilityRepository = instance(),
            getPolicies = instance(),
            staffRepository = instance()
        )
    }
    bindProvider { com.evoapps.evoshift.domain.usecase.todo.GetRosterProgressUseCase(instance(), instance()) }
    // SH-263: published months with changes not published yet (the rosters list's badge).
    bindProvider { com.evoapps.evoshift.domain.usecase.roster.ObserveUnpublishedChangesUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.start.ObserveStartFactsUseCase(instance(), instance(), instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.start.StartPathProgressUseCase(instance()) }
    // SH-239: "Recommend EVoShift" and the owner's "Invite the team" card.
    bindProvider { com.evoapps.evoshift.domain.usecase.growth.GetReferralLinkUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.growth.ObserveTeamJoinUseCase(instance(), instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.budget.GetMissingPayUseCase(instance(), instance(), instance(), caller = instance(), labourInclusion = instance()) }
    bindProvider {
        com.evoapps.evoshift.domain.budget.SetWorksUnpaidUseCase(
            instance(), instance(), instance(), instance(), changes = instance(), caller = instance()
        )
    }
    bind<RegenerateDailyRecordsUseCase>() with singleton { RegenerateDailyRecordsUseCase(instance(), instance(), caller = instance()) }
    // SH-123: takings from a sales file (CSV/XLSX); manual figures win.
    bind<ImportDailySalesUseCase>() with singleton { ImportDailySalesUseCase(instance(), instance(), caller = instance()) }
    bind<CallerCapabilities>() with singleton { CallerCapabilities(instance()) }
    bind<GetRevenuePlanUseCase>() with singleton { GetRevenuePlanUseCase(instance(), instance(), caller = instance()) }
    bind<GetMonthTrendUseCase>() with singleton { GetMonthTrendUseCase(instance(), instance()) }
    // SH-225: sales against last week and last year, one range query per period.
    bind<com.evoapps.evoshift.domain.usecase.finance.GetSalesComparisonUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.finance.GetSalesComparisonUseCase(instance(), caller = instance())
    }
    // SH-54: rule-based staffing hints (labour % of expected sales against the workplace's band).
    // SH-120: suggested daily targets and headcount from the workplace's sales history.
    bind<GetSalesForecastUseCase>() with singleton {
        GetSalesForecastUseCase(instance(), instance(), instance(), caller = instance())
    }
    bind<GetStaffingHintsUseCase>() with singleton {
        GetStaffingHintsUseCase(
            instance(), instance(), instance(), instance(), caller = instance(), getSalesForecast = instance(),
            teamCostRate = instance()
        )
    }
    // SH-115: the labour budget (money: VIEW_FINANCES only) and its settings.
    bind<com.evoapps.evoshift.domain.usecase.finance.GetLabourBudgetUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.finance.GetLabourBudgetUseCase(
            instance(), instance(), instance(), instance(), caller = instance(), teamCostRate = instance(),
            userRepository = instance(), interviewRepository = instance(), labourInclusion = instance()
        )
    }
    bind<com.evoapps.evoshift.domain.usecase.finance.GetTeamCostRateUseCase>() with singleton {
        com.evoapps.evoshift.domain.usecase.finance.GetTeamCostRateUseCase(instance(), instance(), caller = instance(), labourInclusion = instance())
    }
    bindProvider { com.evoapps.evoshift.domain.usecase.finance.SaveLabourBudgetUseCase(instance()) }
    bind<ApplyWeeklyAvailabilityTemplateUseCase>() with singleton { ApplyWeeklyAvailabilityTemplateUseCase() }

    // Onboarding and the owner's plan (SH-38). BillingRepository is bound per platform (composeApp).
    bindProvider { CreateStarterScheduleUseCase(instance()) }
    bind<ObserveOwnerPlanUseCase>() with singleton { ObserveOwnerPlanUseCase(instance(), instance(), instance()) }
    bindProvider { CheckPlanLimitUseCase(instance()) }
    bindProvider { CheckSeatsUseCase(instance(), instance()) }
    bindProvider { ObserveWorkplacePlanUseCase(instance()) }
    bindProvider { ObservePlanActiveUseCase(instance(), instance()) }
    bindProvider { ObserveSeatsInUseUseCase(instance(), instance(), instance()) }
    bindProvider { GetPlanOffersUseCase(instance()) }
    bindProvider { PurchasePlanUseCase(instance()) }
    bindProvider { RestorePurchasesUseCase(instance()) }
    bindProvider { ManageSubscriptionUseCase(instance()) }
    bindProvider { ResetBillingIdentityUseCase(instance()) }

    // GDPR (SH-27): data exports built by functions/dataExport.js.
    bindProvider { ExportMyDataUseCase(instance(), instance()) }
    // SH-94: the person's own profile photo.
    bindProvider { UploadProfilePhotoUseCase(instance()) }
    bindProvider { RemoveProfilePhotoUseCase(instance()) }
    bindProvider { ExportWorkplaceDataUseCase(instance(), instance()) }
    // SH-117: the month's working time for the accountant (functions/accountantExport.js).
    bindProvider { com.evoapps.evoshift.domain.usecase.reports.ExportForAccountantUseCase(instance(), instance()) }

    // SH-45: the roster by e-mail, "Add to calendar" and the calendar link.
    bindProvider { com.evoapps.evoshift.domain.usecase.calendar.ExportShiftCalendarUseCase(instance(), instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.calendar.EmailRosterUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.calendar.PrintRosterUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.calendar.ManageCalendarFeedUseCase(instance()) }

    // SH-118: team announcements and shift notes.
    bindProvider { com.evoapps.evoshift.domain.usecase.team.PostAnnouncementUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.team.MarkAnnouncementsReadUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.team.SaveShiftNoteUseCase(instance(), instance(), instance()) }
    // SH-125: hiring - job posts and applicants.
    bindProvider { com.evoapps.evoshift.domain.usecase.hiring.SaveJobPostUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.hiring.SetJobPostStatusUseCase(instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.hiring.SetApplicantStatusUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.hiring.MarkApplicantHiredUseCase(instance(), instance()) }
    // SH-210: rejecting with an e-mail, interviews.
    bindProvider { com.evoapps.evoshift.domain.usecase.hiring.RejectApplicantUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.hiring.ScheduleInterviewUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.hiring.CancelInterviewUseCase(instance()) }
    // SH-121: opening/closing checklists.
    bindProvider { com.evoapps.evoshift.domain.usecase.checklist.ObserveChecklistTemplatesUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.checklist.SaveChecklistTemplateUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.checklist.DeleteChecklistTemplateUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.checklist.TickChecklistItemUseCase(instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.checklist.ObserveShiftChecklistsUseCase(instance(), instance(), instance()) }
    bindProvider { com.evoapps.evoshift.domain.usecase.checklist.ObserveDayChecklistsUseCase(instance(), instance(), instance()) }
}
